import type { LayoutState, AreaDef } from './types';

export type LayoutAction =
  | { type: 'ADD_AREA'; areaId: string; name: string; start: number; count: number }
  | { type: 'EDIT_AREA'; id: string; name: string; start: number; count: number }
  | { type: 'REMOVE_AREA'; id: string }
  | { type: 'REORDER_AREAS'; orderedIds: string[] };

export function layoutReducer(state: LayoutState, action: LayoutAction): LayoutState {
  switch (action.type) {
    case 'ADD_AREA': {
      const maxSort = state.areas.reduce((m, a) => Math.max(m, a.sortOrder), -1);
      const area: AreaDef = {
        id: action.areaId,
        name: action.name,
        start: action.start,
        count: action.count,
        sortOrder: maxSort + 1,
      };
      return { ...state, areas: [...state.areas, area] };
    }

    case 'EDIT_AREA': {
      const areas = state.areas.map((a) =>
        a.id === action.id
          ? { ...a, name: action.name, start: action.start, count: action.count }
          : a
      );
      return { ...state, areas };
    }

    case 'REMOVE_AREA': {
      const areas = state.areas.filter((a) => a.id !== action.id);
      return { ...state, areas };
    }

    case 'REORDER_AREAS': {
      const byId = new Map(state.areas.map((a) => [a.id, a]));
      const ordered = action.orderedIds
        .map((id) => byId.get(id))
        .filter((a): a is AreaDef => a !== undefined)
        .map((a, idx) => ({ ...a, sortOrder: idx }));
      const orderedIds = new Set(ordered.map((a) => a.id));
      const leftovers = state.areas
        .filter((a) => !orderedIds.has(a.id))
        .map((a, idx) => ({ ...a, sortOrder: ordered.length + idx }));
      return { ...state, areas: [...ordered, ...leftovers] };
    }

    default:
      return state;
  }
}
